export const ROUTES = {
  home: "/",
  login: "login",
  resetPassword: "password-reset",
  forgotPassword: "/forgot-password",
  notFound: "/not-found",
  internalError: "/internal-error",
  features: "/features",
  organizations: "/organizations",
  organizationFeatures: "/organizations/:id/features",
  organizationInfo: "/organizations/:id/info",
  organizationInvitations: "/organizations/:id/invitations",
  organizationSeats: "/organizations/:id/seats",
} as const;
